export enum Event {
  CLICKED = 'clicked',
  CLICKED_DISCOVER_SERVICE = 'clicked-discover-service',
  CLICKED_FEATURED_POST = 'clicked-featured-post',
  CLICKED_LOST_ACCESS_CODE = 'clicked-lost-access-code',
  CLICKED_NEXT_POST = 'clicked-next-post',
  CLICKED_RELATED_POST = 'clicked-related-post',
  CLICKED_SEARCH_RESULT = 'clicked-search-result',
  COOKIE_OPTIN_FIRST_SCREEN = 'cookie-optin-first_screen',
  COOKIE_OPTIN_OPTIONS_SCREEN_ALLOW = 'cookie-optin-options_screen_allow',
  COOKIE_OPTIN_OPTIONS_SCREEN_CLOSE = 'cookie-optin-options_screen_close',
  DISMISSED_FEATURED_POST = 'dismissed-featured-post',
  FOLLOWED_USER = 'followed-user', // not used, only in BG
  NEEDS_ASSESSMENT = 'needs-assessment',
  PROFILE_SURVEY = 'profile-survey',
  SAW_OOPS_PAGE = 'saw-oops-page',
  SEARCHED_COMMUNITY = 'searched-community',
  SEARCHED_SITE = 'searched-site',
  SIGNED_UP = 'signed-up',
  SKIPPED_FEATURED_POST = 'skipped-featured-post',
  VIEWED_COMMUNITY = 'viewed-community',
  VIEWED_FEATURED_POST_UNIQUE = 'viewed-featured-post-unique',
  VIEWED_FEATURED_POST = 'viewed-featured-post',
  VIEWED_NEWSFEED = 'viewed-newsfeed',
  VIEWED_PAGE = 'viewed-page',
  VIEWED_POST = 'viewed-post',
  VIEWED_TAG_PAGE = 'viewed-tag-page',
  VIEWED_USER = 'viewed-user',
}

export const ANONYMOUS_EVENTS = [
  Event.CLICKED,
  Event.VIEWED_PAGE,
];

export enum Section {
  AboutPage = 'about-page',
  AboutUs = 'about-us',
  Alerts = 'alerts',
  Chat = 'chat',
  Communities = 'communities',
  CommunitiesJoin = 'communities-join',
  COMMUNITY = 'Community',
  COMMUNITY_ABOUT = 'CommunityAbout',
  COMMUNITY_HOME_POST = 'CommunityHomePost',
  COMMUNITY_MEMBERS = 'CommunityMembers',
  COMMUNITY_POSTS_POLL = 'CommunityPostsPoll',
  CommunityAbout = 'community-about',
  CommunityHome = 'community-home',
  CommunityHomeSideBar = 'community-home-side-bar',
  CommunityMembers = 'community-members',
  CommunityPoll = 'community-poll',
  CommunityPost = 'community-post',
  CommunityPosts = 'community-posts',
  CommunityPostsSideBar = 'community-posts-side-bar',
  CommunitySearch = 'community-search',
  CommunitySideBar = 'community-side-bar',
  CompletedProgram = 'completed-program',
  ConvBoxReply = 'ConvBoxReply',
  CONVERSION_HIDDEN_RESP = 'ConvBoxReply',
  DiscoverSeeMore = 'discover-seemore',
  Edit = 'edit',
  EditProfile = 'editprofile',
  EmailConfirmationModal = 'email-confirmation-modal',
  Followers = 'followers',
  FollowersFollowings = 'followers-followings',
  Home = 'home',
  HULogo = 'hu-logo',
  Join = 'join',
  Login = 'login',
  LoginModal = 'login-modal',
  ManageAll = 'manage-all',
  MarkSectionAsComplete = 'mark-section-as-complete',
  MemberCardProfileFollowers = 'member-card-profile-followers',
  MemberCardSpp = 'member-card-spp',
  Members = 'members',
  MobileShortcut = 'mobile-shortcut',
  More = 'more',
  MyHub = 'my-hub',
  NeedsAssessmentReport = 'needs-assessment-report',
  NewsFeedEmptyStateJoinCommunities = 'news-feed-empty-state-join-communities',
  NewsFeedFinishReadingPost = 'news-feed-finish-reading-post',
  NewsFeedLatestReply = 'news-feed-latest-reply',
  NewsFeedPost = 'news-feed-post',
  NewsFeedProfile = 'news-feed-profile',
  NewsFeedSidebar = 'news-feed-sidebar',
  NewsFeedWritePost = 'news-feed-write-post',
  NEXT_POSTS = 'Next Posts',
  PartnersLearnMore = 'partners-learnmore',
  POST = 'Post',
  POST_REPLY = 'PostReply',
  PostMore = 'post-more',
  PostPage = 'post-page',
  PostsSideBar = 'posts-side-bar',
  PressLinks = 'press-links',
  ProfileAbout = 'profile-about',
  ProfileHeader = 'profile-header',
  ProfileNavbar = 'profile-navbar',
  ProfilePosts = 'profile-posts',
  ProfileReplies = 'profile-replies',
  Program = 'programe',
  PUBLIC_PROFILE = 'public-profile',
  Reply = 'reply',
  ReplyMore = 'reply-more',
  Resources = 'resources',
  Search = 'search',
  SEARCH_COMMUNITY_CARD = 'SearchCommunityCard',
  SEARCH_TIPS = 'SearchTips',
  SearchBar = 'search-bar',
  SecondPost = 'second-post',
  SeeResearch = 'see-research',
  SinglePost = 'single-post',
  StickyFooter = 'sticky-footer',
  Tag = 'Tag',
  TagsSeeAll = 'tags-seeall',
  TurnOffRepliesModal = 'turn-off-replies-modal',
  UnsubscribeAllAccepted = 'unsubscribe-all-accepted',
  UnsubscribeAllViewed = 'unsubscribe-all-viewed',
  UnsubscribePage = 'unsubscribe-page',
  UNTRACKED = 'UNTRACKED',
  UserQuoteTestimonial = 'userquote-testimonial',
}
export enum Element {
  ASK_HEALTH_QUESTION_LINK = 'AskHealthQuestionLink',
  AVATAR = 'Avatar',
  BUTTON = 'Button',
  CONTACT_US = 'ContactUs',
  EDIT = 'Edit',
  EMAIL = 'Email',
  ENROLL_PROGRAM = 'EnrollProgram',
  FACEBOOK = 'Facebook',
  FIND_OTHERS_LINK = 'FindOthersLink',
  FOLLOW = 'Follow',
  HealthInterests = 'HealthInterests',
  ImproveModule = 'improve-module',
  Join = 'join',
  LIKE = 'Like',
  LINK = 'Link',
  LOGIN = 'Login',
  MemberTab = 'Member-tab',
  MemberTag = 'member-tag',
  PollButton = 'poll-button',
  PollTitle = 'poll-title',
  PROGRAM_MODULE_NEXT_LINK = 'ProgramModuleNextLink',
  PROGRAM_MODULE_PREVIOUS_LINK = 'ProgramModulePreviousLink',
  PROGRAM_SECTION_MARK_AS_COMPLETE = 'ProgramSectionMarkAsComplete',
  PROGRAM_SECTION_TOGGLE_SECTION = 'ProgramSectionToggleSection',
  PROMO_IMAGE = 'PromoImage',
  QuestionMark = 'question-mark',
  RelatedPost = 'related-post',
  REPLY = 'Reply',
  REPLY_HIDDEN_LINK = 'ReplyHiddenLink',
  REPLY_SUBMIT = 'SubmitReply',
  REPORT = 'Report',
  SeeAllTopics = 'see-all-topics',
  SeeMoreRelatedPosts = 'see-more-related-posts',
  SIGNUP = 'Signup',
  TAKE_HEALTH_NEEDS_QUIZ_LINK = 'TakeHealthNeedsQuizLink',
  Topic = 'topic',
  UNTRACKED = 'UNTRACKED',
  USER_LINK = 'UserLink',
  VisitorPrompt = 'visitor-prompt',
  Vote = 'vote',
  VOTE = 'Vote',
  WRITE = 'Write',
  WritePost = 'write-post',
}

export type FootfallContextType = {
  element?: Element;
  section: Section;
}
